export const stripTrailingNumeral = (name: string) =>
  name.replace(/\s+/g, " ").replace(/^\s*\d+\s*#\s*/, "").replace(
    /\s*\d+\s*$/,
    "",
  ).trim();
